/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from "axios";
import QS from "qs";
import { message } from "ant-design-vue";
import router from "./router/router";
// import store from "../store/index";

// 环境的切换 
if (process.env.NODE_ENV == "development") {
  axios.defaults.baseURL = "http://127.0.0.1:8888";    
  // axios.defaults.baseURL = "https://api.wziqi.cc";    
} else if (process.env.NODE_ENV == "debug") {
  axios.defaults.baseURL = "http://127.0.0.1:8888";
  // axios.defaults.baseURL = "https://api.wziqi.cc";
} else if (process.env.NODE_ENV == "production") {
  axios.defaults.baseURL = "https://api.wziqi.cc";
}

// 请求超时时间
axios.defaults.timeout = 10000;

// post请求头
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";

// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    // const token = store.state.token;
    const token = localStorage.getItem("calltoken");
    const tt = localStorage.getItem("saveTokenTime");
    // 超过1小时踢出去
    if(Date.now() - parseFloat(tt) > 3600*1000 && config.url != '/login') {
      localStorage.removeValue('calltoken');
      
      localStorage.removeValue('saveTokenTime');
      router.push({ path: "/" });
    }
    token && (config.headers.Authorization = "Bearer " + token);
    return config;
  },
  (error) => {
    return Promise.error(error);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.status >= 200 && response.status < 300) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况
  (error) => {
    //console.log('接口报错了####');
    //console.log(error.response.status);
    //console.log(error);
    //console.log(error.message);
    if (error) {      
      switch (error.response.status) {
        case 400:
          message.error("请求错误，请调整参数后重试!");
          break;
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          //console.log("来 401 了");
          localStorage.removeItem("calltoken");
          localStorage.removeValue('saveTokenTime');
          router.push({ path: "/" });
          // router.push({ path: "/" });
          break;
        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 403:
          message.error("登录过期，请重新登录");
          // 清除token
          localStorage.removeItem("calltoken");
          localStorage.removeValue('saveTokenTime');
          router.push({ path: "/" });
          break;
        // 404请求不存在
        case 404:
          message.error("网络请求不存在");
          break;
        case 500:
          message.error("服务异常，请稍后重试");
          break;
        // 其他错误，直接抛出错误提示
        default:
          if (
            error.response.data.message &&
            error.response.data.message.length > 0
          ) {
            message.error(error.response.data.message);
          } else {
            message.error("请求失败，请稍后重试!");
          }
      }
      // message.error(error.message);
      return Promise.reject(error.response);
    }
    // message.error(error.message);
    // return Promise.reject(error);
  }
);
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,        
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

export function imgDown(url) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        responseType: "blob",
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

export function del(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, {
        params: params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

export function put(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .put(url, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

export function upload(url, fileData) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, fileData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err.data);
      });  
  });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      // .post(url, JSON.stringify(params), {
      .post(url, params, {
        headers: {
          Accept: "text/plain",
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((res) => {
        console.log("接口回来了" + res);
        resolve(res.data);
      })
      .catch((err) => {
        //console.log("接口回来了---报错了" + err.data);
        if (err.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          //console.log(err.response.data); // 如果服务器返回的错误数据是 9，那么这里就会打印出 9
        } else if (err.request) {
          // The request was made but no response was received
          //console.log(err.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          //console.log("Error", err.message);
        }
        reject(err.data);
      });
  });
}
